import { keepPreviousData, QueryClient, useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import {
  getDefaultModules,
  getModuleById,
  getModules,
  getModulesBySelectionForCourses
} from '../modulesService';

export const invalidateModulesQuery = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({ queryKey: ['modules'] });
};

export const invalidateDefaultModulesQuery = (queryClient: QueryClient) => {
  return queryClient.invalidateQueries({ queryKey: ['defaultmodules'] });
};

export const useModulesById = (id: number, config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['modules', id],
    queryFn: () => {
      return getModuleById(id, config);
    },
    initialData: undefined
  });
};

export const useModulesQuery = (config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['modules', config ? JSON.stringify(config) : ''],
    queryFn: () => {
      return getModules(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useDefaultModulesQuery = (config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['defaultmodules', config ? JSON.stringify(config) : ''],
    queryFn: () => {
      return getDefaultModules(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useModulesBySelectionForCoursesQuery = (config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['modulesbyselectionForCourses', config ? JSON.stringify(config) : ''],
    queryFn: () => {
      return getModulesBySelectionForCourses(config);
    }
  });
};
